module.exports = __webpack_public_path__ + "static/arco-5c73ad919e0703bc6638ab2dfbe3caf9.mp4";